import { ValueOfKey } from '../../../../utils-types';

export const REPORT_TYPE = {
  RESULT_SHEET: 'RESULT_SHEET',
  PROGRESS_REPORT: 'PROGRESS_REPORT',
} as const;

export type ReportType = ValueOfKey<typeof REPORT_TYPE>;
